import angular from "angular";
import { ApiClient } from "@topline/services/apiService";
import { ScoringCardsReportComponent } from "./components/scoringCardsReport.component";
import { angularServicesNames } from "@topline/services/angularServicesNames";

class ScoringCardsConfig {
    static $inject = ["$stateProvider"];

    constructor(private $stateProvider: ng.ui.IStateProvider) {
        this.init();
    }

    private init() {
        this.$stateProvider
            .state("scoringCards", {
                abstract: true,
                resolve: {
                    translateReady: [
                        angularServicesNames.$translate,
                        ($translate: ng.translate.ITranslateService) => {
                            return $translate.onReady();
                        }
                    ]
                }
            })
            .state("scoringCards.report", {
                url: "^/scoring-cards/report",
                component: ScoringCardsReportComponent.componentName,
                resolve: {
                    budgetVersions: [
                        ApiClient.componentName,
                        (apiClient: ApiClient) => apiClient.getBudgetVersionsForDate(new Date())
                    ]
                }
            });
    }
}

angular.module("topline.modules").config(ScoringCardsConfig);
